import React from 'react';
import { render } from 'react-dom';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import { FadeLoader, ClipLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

export class ResponseSpinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    //this.changeState = this.changeState.bind(this);
  }

  /*changeState() {
    this.setState({
      hideVals: true
    });
  }*/

  render() {
    var currentComponent = this;
    /*  setTimeout(function() {
        currentComponent.changeState();
      }, 3500);*/
    //console.log(this.props.loading);
    return (
      <div style={{ maxHeight: '10px' }}>
        {/*<FadeLoader height={5} width={2} color={'#123abc'}  loading={this.props.loading} />*/}
        {this.props.loading == 'loading' && (
          <ClipLoader
            style={{ paddingLeft: '5px' }}
            size={25}
            color={'#123abc'}
            loading={this.props.loading == 'loading'}
          />
        )}
        {this.props.loading == 'success' && (
          <FontAwesomeIcon
            style={{
              color: 'green',
              fontSize: '34px',
              paddingLeft: '5px',
              paddingTop: '0px'
            }}
            icon={faCheck}
          />
        )}
        {this.props.loading == 'failure' && (
          <FontAwesomeIcon
            style={{
              color: 'Tomato',
              fontSize: '34px',
              paddingLeft: '5px',
              paddingTop: '0px'
            }}
            icon={faTimes}
          />
        )}
      </div>
    );
  }
}
export default ResponseSpinner;



// WEBPACK FOOTER //
// ./src/Components/ResponseSpinner.js